// Custom components
import React from "react";

function InputField(props: {
  id: string;
  label: string;
  extra: string;
  placeholder: string;
  variant: string;
  state?: string;
  disabled?: boolean;
  type?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  const { label, id, extra, type, placeholder, variant, state, disabled, value, onChange } =
    props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-ink ${ variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        }`}
      >
        {label}
      </label>
      <input
        disabled={disabled}
        type={type}
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`mt-2 flex h-12 w-full items-center justify-center rounded-2xl border bg-surface-muted px-4 text-sm outline-none transition-colors duration-200 focus:border-brand-500 focus:bg-surface focus:ring-4 focus:ring-brand-100/70 dark:focus:ring-brand-500/20 ${
          disabled === true
            ? "!border-none !bg-surface-hover dark:placeholder:!text-gray-400"
            : state === "error"
            ? "border-danger-600 text-danger-600 placeholder:text-danger-500 dark:!border-danger-600 dark:!text-danger-600 dark:placeholder:!text-danger-500 dark:text-red-300"
            : state === "success"
            ? "border-success-500 text-success-600 placeholder:text-success-500 dark:!border-success-500 dark:!text-success-600 dark:placeholder:!text-success-500 dark:text-green-300"
            : "border-line text-ink placeholder:text-ink-subtle"
        }`}
      />
    </div>
  );
}

export default InputField;
